import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Image360 } from './core/image360.model';

declare let Magic360: any;

@Component({
  selector: 'magic-360',
  standalone: true,
  imports: [],
  templateUrl: './magic-360.component.html',
  styleUrl: './magic-360.component.scss',
})
export class Magic360Component implements OnInit, AfterViewInit {
  @Input() image360!: Image360;
  firstNormalImage = '';
  firstLargeImage = '';
  config = ``;

  ngOnInit(): void {
    this.populateImage360();
  }

  ngAfterViewInit(): void {
    Magic360.start();
  }

  populateImage360() {
    const normalImages = this.image360?.normal || ``;
    const largeImages = this.image360?.large ? this.image360?.large : this.image360?.normal;
    const tableIndex = this.getTableIndex(largeImages.split(' '));

    this.firstNormalImage = normalImages?.split(' ')[0];
    this.firstLargeImage = largeImages ? largeImages?.split(' ')[0] : normalImages?.split(' ')[0];
    this.config = `autospin-speed: 3000, magnify: false; rows: ${tableIndex.qtyRows}; columns: ${tableIndex.qtyColumns}; images: ${normalImages}; large-images: ${largeImages};`;
  }

  getTableIndex(fileList: string[]): { qtyRows: number; qtyColumns: number } {
    let qtyRows = 0;
    let qtyColumns = 0;

    fileList.forEach(file => {
      const indexLastDot = file?.lastIndexOf('.');
      const fileNames = file?.slice(0, indexLastDot);
      const dirtReference = fileNames?.slice(-5);
      const references = dirtReference?.split('_');

      qtyRows = parseInt(references[0] || `0`);
      qtyColumns = parseInt(references[1] || `0`);
    });

    return { qtyRows, qtyColumns };
  }
}
